<div>
    <h2 class="body-sm-14-semibold">Output Helpers</h2>
    <ul>
        @for (helperOption of outputHelpersOptions; track helperOption.id) {
            <li
                class="output-helper"
                (click)="onOptionClicked(helperOption.id)"
                [ngClass]="{ border: helperOption.isChecked }"
            >
                <div
                    class="output-helper-container"
                    epdTooltip
                    epdTooltipTitle="{{ helperOption.tooltip }}"
                    epdTooltipPlacement="left"
                >
                    <epd-icon
                        [ngClass]="{ 'custom-size': helperOption.id === 2 }"
                        [size]="helperOption.iconSize"
                        [type]="helperOption.iconType"
                        [color]="helperOption.iconColor"
                    />
                    <div class="output-helper-text">
                        <p class="body-xs-12-semibold">{{ helperOption.title }}</p>
                    </div>
                </div>
                <epd-icon [hidden]="!helperOption.isChecked" [size]="'medium'" [type]="'check-checkbox'" />
            </li>
        }
    </ul>
</div>
